import {Injectable} from '@angular/core';
import {HttpClient, HttpContext} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Product} from '../models/product';
import {SKIP_ERROR_INTERCEPTOR} from '../app/interceptors/error.interceptor';

const API = environment.API;

@Injectable({
  providedIn: 'root',
})
export class ProductService {

  TYPE = {
    MEMBERSHIP: 'membership',
    VOUCHER: 'voucher',
    PACK: 'pack',
    EXTRA: 'extra',
  };

  MEMBERSHIP_TYPE = {
    NONE: 'none',
    PLAIN: 'plain',

    TRIAL: 'trial',
    NEWBIE: 'newbie',
    MONTHLY: 'monthly',

    LEMON: 'lemon',
    CHERRY: 'cherry',
    ALMOND: 'almond',

    APPLE: 'apple',
    HOBBYIST: 'hobbyist',
    INTERN: 'intern',

    ONEDAY: 'oneday',
    THREEDAY: 'threeday',
    SEVENDAY: 'sevenday',

    CINNAMON: 'cinnamon',
    NUTELLA: 'nutella',
    APRICOT: 'apricot',

    CHOCOLATE: 'chocolate',
    VANILLA: 'vanilla',

    RASPBERRY: 'raspberry',
    STRAWBERRY: 'strawberry',
    BLUEBERRY: 'blueberry',
  };

  EXTRA_TYPE = {
    EXTRA_VISIT: 'extra-visit',
    EXTRA_GUEST: 'extra-guest',
    EXTRA_PASS: 'extra-pass',
    EXTRA_CONFERENCE: 'extra-conference',
    EXTRA_RESERVE: 'extra-reserve',
  };

  constructor(private http: HttpClient) {
  }

  getProductDetail(product: Product | null) {
    const detail = {
      hasHourBasedMembership: false,
      hasFlexBasedMembership: false,
      hasPassBasedMembership: false,

      hasUnlimitedMembership: false,
      hasLimitedMembership: false,

      hasFixedMembership: false,
      hasRecurringMembership: false,
      hasEndlessMembership: false,

      hasRolloverMembership: false,
    };

    if (product && product.membershipProperties) {
      if (product.membershipProperties.type === 'hour') {
        detail.hasHourBasedMembership = true;
      }
      if (product.membershipProperties.type === 'flex') {
        detail.hasFlexBasedMembership = true;
      }
      if (product.membershipProperties.type === 'pass') {
        detail.hasPassBasedMembership = true;
      }

      if (product.membershipProperties.unlimited) {
        detail.hasUnlimitedMembership = true;
      }
      if (!product.membershipProperties.unlimited) {
        detail.hasLimitedMembership = true;
      }

      if (product.membershipProperties.cycle === 'fixed') {
        detail.hasHourBasedMembership = true;
      }
      if (product.membershipProperties.cycle === 'recurring') {
        detail.hasRecurringMembership = true;
      }
      if (product.membershipProperties.cycle === 'endless') {
        detail.hasEndlessMembership = true;
      }

      if (product.membershipProperties.rollover) {
        detail.hasRolloverMembership = true;
      }
    }

    // Default if there is no product
    if (!product) {
      detail.hasFlexBasedMembership = true;
      detail.hasLimitedMembership = true;
      detail.hasEndlessMembership = true;
      detail.hasRolloverMembership = true;
    }

    return detail;
  }

  createProduct(type: string, name: string, slug: string, description: string, amount: string, currency: string, placeId: string, membershipProperties: any, voucherProperties: any, packProperties: any) {
    const body = {type, name, slug, description, amount, currency, placeId, membershipProperties, voucherProperties, packProperties};
    return this.http.post(`${API}/api/products`, body);
  }

  getById(id: string) {
    return this.http.get<Product>(`${API}/api/products/${id}`);
  }

  getBySlug(slug: string) {
    return this.http.get<Product>(`${API}/api/products/${slug}/slug`, {
      context: new HttpContext().set(SKIP_ERROR_INTERCEPTOR, true)
    });
  }

  findProducts(limit: number, skip: number) {
    return this.http.get<Product[]>(`${API}/api/products`, {params: {limit, skip}});
  }

  findByType(type: string, limit: number, skip: number) {
    return this.http.get<Product[]>(`${API}/api/products/type/${type}`, {params: {limit, skip}});
  }

  search(search: string, excludeIds: string[], limit: number, skip: number) {
    const params = {search, excludeIds, limit, skip};
    return this.http.get(`${API}/api/products/search`, {params});
  }

  deactivate(id: string) {
    return this.http.put(`${API}/api/products/${id}/deactivate`, {});
  }
}
